export const SIZES = {
  xxxxxl: '1.75rem',
  xxxxl: '1.5rem',
  xxxl: '1.375rem',
  xxl: '1.25rem',
  xl: '1.125rem',
  l: '1rem', // 16px by the default
  m: '0.875rem',
  s: '0.75rem',
  xs: '0.625rem',
  xxs: '0.5rem'
};

export const FAMILIES = {
  arial: 'Arial'
};

export const WEIGHTS = {
  thin: '100',
  extra_light: '200',
  light: '300',
  normal: '400',
  medium: '500',
  semi_bold: '600',
  bold: '700',
  extra_bold: '800',
  black: '900'
};
